// Prevent the regular page from scrolling when inside a modal
export const disablePageScroll = () => {
  document.body.style.setProperty("overflow", "hidden", "important");
};
export const enablePageScroll = () => {
  document.body.style.removeProperty("overflow");
};
